/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_SubheadlineInputs */

const he_landing_subheadline = /** @type {(inputs: Landing_SubheadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`תבנית fullstack מוכנה לייצור עם אימות, ריבוי דיירים ועוד.`)
};

const en_landing_subheadline = /** @type {(inputs: Landing_SubheadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A production-ready fullstack template with auth, multi-tenancy, and more.`)
};

/**
* | output |
* | --- |
* | "A production-ready fullstack template with auth, multi-tenancy, and more." |
*
* @param {Landing_SubheadlineInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_subheadline = /** @type {((inputs?: Landing_SubheadlineInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_SubheadlineInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_landing_subheadline(inputs)
	return en_landing_subheadline(inputs)
});